// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__EYNUZ","label":"Radio_label__-yoCg","checkMark":"Radio_checkMark__3Wocc","disabled":"Radio_disabled__1Kpoh"};